var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68868 9.27688C6.68868 9.72792 6.32701 10.0936 5.88095 10.0936C5.43489 10.0936 5.07324 9.72792 5.07324 9.27688C5.07324 8.82585 5.43486 8.46021 5.88095 8.46021C6.32704 8.46021 6.68868 8.82585 6.68868 9.27688Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38104 9.27688C9.38104 9.72792 9.01942 10.0936 8.57336 10.0936C8.12722 10.0936 7.76562 9.72792 7.76562 9.27688C7.76562 8.82585 8.12725 8.46021 8.57336 8.46021C9.01944 8.46021 9.38104 8.82585 9.38104 9.27688Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0724 9.27688C12.0724 9.72792 11.7108 10.0936 11.2647 10.0936C10.8187 10.0936 10.457 9.72792 10.457 9.27688C10.457 8.82585 10.8187 8.46021 11.2647 8.46021C11.7108 8.46021 12.0724 8.82585 12.0724 9.27688Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15625 5.5437H26.6562V24.7937H2.15625V5.5437ZM3.32293 6.71035V23.627H25.4896V6.71035H3.32293Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.dffd439badefdde460ce4235f48a2b24.svg";
export { ForwardRef as ReactComponent };